import { cn } from "@/lib/utils";

export const COMMISSION_EXPLANATION = "Moveload earns 15% commission on the Carrier Base Rate (CBR). For urgent / same-day loads, the combined commission and incentive is 22.5% of CBR: 15% goes to Moveload and the extra 7.5% goes to the transporter. Moveload still earns only 15%. VAT and any separately priced services are additional. Own-fleet movements carry no marketplace commission.";

export function CommissionExplanation({ className }: { className?: string }) {
  return (
    <p className={cn("text-sm text-muted-foreground leading-relaxed", className)}>
      Moveload earns <strong className="text-foreground">15% commission</strong> on the Carrier Base Rate (CBR).
      {" "}For <strong className="text-foreground">urgent / same-day loads</strong>, the combined commission and incentive is
      {" "}<strong className="text-foreground">22.5% of CBR</strong>: 15% goes to Moveload and the
      {" "}<strong className="text-foreground">extra 7.5% goes to the transporter</strong>. Moveload still earns only 15%.
      {" "}VAT and any separately priced services are additional. Own-fleet movements carry no marketplace commission.
    </p>
  );
}